import script from "./GeneralOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralOptions.vue?vue&type=script&setup=true&lang=js"

import "./GeneralOptions.vue?vue&type=style&index=0&id=694f7608&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-694f7608"]])

export default __exports__